import axios from "axios"

if (process.env.NODE_ENV !== "production") {
  axios.defaults.baseURL = "http://localhost:3030"
}

// MARK: State
const state = () => ({
  flagTypes: [],
  userTodos: [],
})

// MARK: Getters
const getters = {
  getFlagTypes(state) {
    return state.flagTypes
  },
  getUserTodos(state) {
    return state.userTodos
  },
}

// MARK: Actions
const actions = {
  async createTodoEntry({ dispatch }, payload) {
    console.log('createTodoEntry', payload)
    const response = await axios
      .post("/api/todos/", payload, {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })

    if (response && response.data) {
      dispatch("listUserTodos", { userId: payload.userId })
    }
  },
  async updateTodoEntry({ dispatch }, payload) {
    console.log('updateTodoEntry', payload)
    const response = await axios
      .post("/api/todos/update", payload, {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })

    if (response && response.data) {
      dispatch("listUserTodos", { userId: payload.userId })
    }
  },
  async deleteTodoEntry({ dispatch }, payload) {
    console.log('updateTodoEntry', payload)
    const response = await axios
      .post("/api/todos/delete", payload, {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })

    if (response && response.data) {
      dispatch("listUserTodos", { userId: payload.userId })
    }
  },
  async listUserTodos({ commit }, payload) {
    const response = await axios
      .get("/api/todos/" + payload.userId, {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })
    if (response && response.data) {
      commit("setListUserTodos", handleIfArray(response.data))
    }
  },
  async listFlagTypes({ commit }) {
    const response = await axios
      .get("/api/todos/listFlagTypes", {
        withCredentials: false,
        credentials: "include",
        headers: {
          "x-access-token": localStorage.getItem("access_token"),
        },
      })
      .catch((err) => {
        console.log("err:", err)
      })
    if (response && response.data) {
      commit("setListFlagTypes", response.data)
    }
  }
}

// MARK: Mutations
const mutations = {
  setListUserTodos(state, data) {
    state.userTodos = data
  },
  setListFlagTypes(state, data) {
    state.flagTypes = data
  },
  setLogout(state) {
    state.flagTypes = []
    state.userTodos = []
  }
}

function snakeToCamel(string) {
  let splitStringArr = string.split("_");
  let builtStr = splitStringArr.reduce((acc, curr, i) => {
    curr = i !== 0 ? curr[0].toUpperCase() + curr.slice(1) : curr;
    return acc + curr;
  }, "");
  return builtStr;
}

function handleIfArray(response) {
  if (Array.isArray(response)) {
    let newResponse = []
    response.forEach(element => {
      newResponse.push(convertResponse(element))
    });
    return newResponse
  } else {
    return convertResponse(response)
  }
}

function convertResponse(response) {
  let parentKeys = Object.keys(response);
  parentKeys.forEach((key) => {
    let currentObj = response[key];
    delete response[key];
    let newKey = snakeToCamel(key);
    response[newKey] = currentObj;
    if (typeof response[newKey] === "object" && response[newKey] != null) {
      convertResponse(response[newKey]);
    }
  });
  return response;
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
